import type { Cvpartner } from 'Cvpartner';
import { invariant } from 'util/invariant';

export function getCvPartner(): Cvpartner {
  const cvpartner = (window as unknown as { cvpartner?: Cvpartner }).cvpartner;
  invariant(cvpartner, 'CVPartner is not initialized');
  return cvpartner;
}

export function skipFetchingUser(pathname = window.location.pathname) {
  const isOnLoginPage = pathname === '/login';
  const isOnAdminLoginPage = pathname === '/login/admin';
  const isOnOtpPage = pathname === '/login/otp';
  const isOnLogoutPage = pathname === '/logout';

  return isOnLoginPage || isOnAdminLoginPage || isOnOtpPage || isOnLogoutPage;
}
